import { useState, useEffect, useRef } from 'react'
import produce from 'immer'
import { v4 as uuid } from 'uuid'
import { Wrapper, Buttons, Button, Table } from './styledEdit'
import Cols from './editComponents/Cols'
import Rows from './editComponents/Rows'
import SettingsModal from './editComponents/SettingsModal'

const defaultCol = {}

const defaultRow = {}

const defaultCell = {
  expr: '',
  defaultValue: ''
}

const DatasheetEdit = props => {
  const { extra, id, save } = props

  const { cols: extraCols, rows: extraRows } = extra

  const [cols, setCols] = useState(extraCols)
  const [rows, setRows] = useState(extraRows)
  const [settingsDraft, setSettingsDraft] = useState(null)

  const didMountRef = useRef(false) // implement this in useEffects

  useEffect(() => {
    save({ _id: id, key: 'cols', value: cols })
  }, [cols])

  useEffect(() => {
    save({ _id: id, key: 'rows', value: rows })
  }, [rows])

  const addRow = idx => {
    setRows(produce(draft => {
      if (idx === undefined) {
        draft.push({ id: uuid(), ...defaultRow, cells: cols.map(() => ({ id: uuid(), ...defaultCell })) })
      }
      else {
        draft.splice(idx, 0, { id: uuid(), ...defaultRow, cells: cols.map(() => ({ id: uuid(), ...defaultCell })) })
      }
    }))
  }

  const removeRow = idx => {
    setRows(produce(draft => {
      draft.splice(idx, 1)
    }))
  }

  const addCol = idx => {
    setCols(produce(draft => {
      if (idx === undefined) {
        draft.push({ id: uuid(), ...defaultCol })
      }
      else {
        draft.splice(idx, 0, { id: uuid(), ...defaultCol })
      }
    }))

    setRows(produce(draft => {
      draft.forEach(({ cells }) => {
        if (idx === undefined) {
          cells.push({ id: uuid(), ...defaultCell })
        }
        else {
          cells.splice(idx, 0, { id: uuid(), ...defaultCell })
        }
      })
    }))
  }

  const removeCol = idx => {
    setCols(produce(draft => {
      draft.splice(idx, 1)
    }))

    setRows(produce(draft => {
      draft.forEach(({ cells }) => {
        cells.splice(idx, 1)
      })
    }))
  }

  const onChange = ({ type, rowIdx, cellIdx, key, value }) => {
    switch (type) {
      case 'col':
        setCols(produce(draft => {
          draft[cellIdx][key] = value
        }))

        break
      case 'row':
        setRows(produce(draft => {
          draft[rowIdx].cells[cellIdx][key] = value
        }))

        break
      default:
        return
    }
  }

  return (
    <Wrapper>
      <Buttons>
        <Button onClick={() => addRow()}>Add row</Button>
        <Button onClick={() => addCol()}>Add col</Button>
      </Buttons>
      <Table>
        <Cols cols={cols} setSettingsDraft={setSettingsDraft} addCol={addCol} removeCol={removeCol} />
        <Rows rows={rows} cols={cols} setSettingsDraft={setSettingsDraft} addRow={addRow} removeRow={removeRow} onChange={onChange} />
      </Table>
      {
        settingsDraft && (
          <SettingsModal {...settingsDraft} setCols={setCols} setRows={setRows} setSettingsDraft={setSettingsDraft} />
        )
      }
    </Wrapper>
  )
}

export default DatasheetEdit